export default {
  // baseUrl: 'http://192.168.31.130:8000/',
	baseUrl: 'http://212.95.51.116:8000',
  //  baseUrl: 'http://127.0.0.1:8000',
  siteUrl: 'dama-co.com/'

}
